(() => {
  const init = (root = document) => {
    root.querySelectorAll('.cft-contact-form').forEach((form) => {
      if (form.dataset.contactReady) return;
      form.dataset.contactReady = 'true';
      const details = form.querySelector('[data-contact-details]');
      const email = form.querySelector('[data-contact-email]');
      const emailField = form.querySelector('[data-contact-email-field]');
      const hint = form.querySelector('[data-contact-error]');
      const sync = () => {
        const value = details.value.trim();
        const isEmail = value.includes('@');
        const phone = value.replace(/[\s().-]/g, '');
        const validPhone = /^\+[1-9]\d{6,14}$/.test(phone);
        emailField.hidden = !value || isEmail;
        if (isEmail || !value) email.value = value;
        email.required = true;
        details.setCustomValidity(isEmail && !email.validity.valid
          ? 'Enter a valid email address.' : value && !isEmail && !validPhone
            ? 'Enter an email address or WhatsApp number with country code.' : '');
        hint.hidden = !value || !details.validationMessage;
        hint.textContent = details.validationMessage;
        details.setAttribute('aria-invalid', String(Boolean(value) && !details.validity.valid));
      };
      details.addEventListener('input', sync);
      details.addEventListener('change', sync);
      form.addEventListener('submit', (event) => {
        sync();
        if (!form.checkValidity()) {
          event.preventDefault();
          if (!details.validity.valid || emailField.hidden) {
            details.setCustomValidity(details.validationMessage || 'Enter a valid email address.');
            details.reportValidity();
          } else {
            email.reportValidity();
          }
        }
      });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
